module.exports = __webpack_public_path__ + "img/gambling.963369d8.png";